import styled from "@emotion/styled";
import { Card } from "antd";

export const HistorialSectionCard = styled(Card)`
  border-radius: 20px;
  border: 1px solid #dbe4f0;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  .ant-card-body {
    padding: 20px 22px;
    display: grid;
    gap: 18px;
  }
`;

export const HistorialSectionTitle = styled.h3`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 800;
  color: #1e3a8a;
`;

export const HistorialSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 24px;
  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const HistorialField = styled.div`
  display: grid;
  gap: 4px;
  min-width: 0;
`;

// Lista de valores con scroll cuando hay muchos productos (más de 10).
export const HistorialScrollList = styled.div`
  display: grid;
  gap: 4px;
  min-width: 0;
  ${({ $scroll }) =>
    $scroll
      ? `max-height: 240px; overflow-y: auto; padding-right: 6px;`
      : ""}
`;

export const HistorialFieldLabel = styled.span`
  color: #334155;
  font-size: 0.82rem;
  font-weight: 800;
`;

export const HistorialFieldValue = styled.span`
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 600;
  word-break: break-word;
`;

export const HistorialTableWrapper = styled.div`
  min-width: 0;
  overflow-x: auto;
`;

export const HistorialDocList = styled.div`
  display: grid;
  gap: 8px;
`;

export const HistorialDocItem = styled.div`
  display: grid;
  gap: 4px;
`;

export const HistorialDocName = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #1e3a8a;
  font-weight: 700;
  font-size: 0.88rem;
  word-break: break-word;
`;

export const HistorialDocActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const HistorialDocLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #1d4ed8;
  font-weight: 700;
  font-size: 0.84rem;
  &:hover {
    text-decoration: underline;
  }
`;

export const HistorialNoDoc = styled.span`
  color: #64748b;
  font-size: 0.88rem;
`;